/**
 * dir-w | backOffice
 * Page title
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    styleUrl: './page-title.component.css',
    standalone: false
})
export class PageTitleComponent {
  @Input() pageTitle: string = `Page title not defined`;
}
